// extracted by mini-css-extract-plugin
module.exports = {"md":"getwallet-home-slot_md_aqzsY","ios":"getwallet-home-slot_ios_3O7lu","block":"getwallet-home-slot_block_17ZBg"};